<template>
  <div class="modal fade" :id="idModal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Registro Rapido de Persona Natural o Juridica </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <div class="btn-group btn-group-toggle" data-toggle="buttons">
                            <label class="btn btn-info active" @click="mTypePerson">
                                <input class="form-check-input radio" type="radio" name="exampleRadios" id="exampleRadios1" value="juridica" v-model="optionPersonReg" checked> Persona Natural
                            </label>
                            <label class="btn btn-info" @click="mTypePerson">
                                <input class="form-check-input radio" type="radio" name="exampleRadios" id="exampleRadios2"  value="natural" v-model="optionPersonReg"> Persona Juridica
                            </label>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-12 col-md-4">
                                <label for="brand_engine" class="badge badge-primary">Nombre(s)</label>
                                <input type="text" class="form-control" v-model="new_person.name" name="flag" placeholder="Nombre" autocomplete="off">
                            </div>
                            <div class="form-group col-12 col-md-4">
                                <label for="brand_engine" class="badge badge-primary">Primer Apellido</label>
                                <input type="text" class="form-control" name="flag" placeholder="Primer Apellido" autocomplete="off" :readonly="!is_natural" v-model="new_person.first_last_name">
                            </div>
                            <div class="form-group col-12 col-md-4">
                                <label for="brand_engine" class="badge badge-primary">Segundo Apellido</label>
                                <input type="text" class="form-control" name="flag" placeholder="Segundo Apellido" autocomplete="off" :readonly="!is_natural" v-model="new_person.second_last_name">
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12 col-md-4">
                                <label for="brand_engine" class="badge badge-primary">Numero Identificacion</label>
                                <input type="text" class="form-control" name="flag" placeholder="Numero de Identificacion" autocomplete="off" v-model="new_person.number_identification">
                            </div>
                            <div class="form-group col-12 col-md-4">
                                <label for="brand_engine" class="badge badge-primary">Expedido</label>
                                <select name="" id="" class="form-control" v-model="new_person.issued">
                                    <option v-for="aux_is in issued" :key="aux_is.id" :value="aux_is.id">{{ aux_is.detail }}</option>
                                </select>
                            </div>
                            <div class="form-group col-12 col-md-4">
                                <label for="brand_engine" class="badge badge-primary">Celular/Telefono</label>
                                <input type="text" class="form-control" name="flag" placeholder="Celular o Telefono" autocomplete="off" v-model="new_person.phone">
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12 col-md-4">
                                <label for="brand_engine" class="badge badge-primary">Pais Origen</label>
                                <select name="" id="" class="form-control" v-model="new_person.nationality">
                                    <option v-for="aux_is in nationality" :key="aux_is.id" :value="aux_is.id">{{ aux_is.detail }}</option>
                                </select>
                            </div>
                            <div class="form-group col-12 col-md-4">
                                <label for="brand_engine" class="badge badge-primary">Genero</label>
                                <select name="" id="" class="form-control" v-if="is_natural" v-model="new_person.genre">
                                    <option v-for="aux_genre in genre" :key="aux_genre.id" :value="aux_genre.id">{{ aux_genre.value }}</option>
                                </select>
                                <input v-else type="text" name="" id="" readonly class="form-control-plaintext" value="Juridica">
                            </div>
                        </div>
                        <br>
                        <button class="btn btn-success col-12 col-md-4 offset-md-4" @click="mSavePerson"><font-awesome-icon icon="save" size="lg" /> Registrar</button>
                                                                       
                    </div>               
                    
                    <div class="modal-footer">
                        
                        <button type="button" class="btn btn-outline-danger" data-dismiss="modal"><font-awesome-icon icon="times-circle" size="lg" /></button>
                        
                    </div>
                </div>
            </div>
            
    </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import qs from 'qs';

export default {
    name:'modal-new-person',
    mounted(){
        this.mCallOptions();
    },
    props:{
        idModal:String
    },
    data(){
        return{
            optionPersonReg:'natural',
            dataSearch:null,
            dataPerson:[],
            nationality:[],
            genre:[{id:'M', value:'MUJER'}, {id:'V', value:'VARON' }],
            issued:[],
            new_person:{
                name:null,
                first_last_name:null,
                second_last_name:null,
                number_identification:null,
                issued:0,
                phone:0,
                nationality:0,
                genre:null
            },
            is_natural:true
        }
    },
    methods:{
        async mCallOptions(){

            let nation=await axios.get(`globals/country?api_token=${Vue.auth.getToken()}`);
            let aux_issued=await axios.get(`globals/citys?api_token=${Vue.auth.getToken()}`);
            
            this.issued=aux_issued.data;
            this.nationality=nation.data;
        },
        mTypePerson(){            
            
                let radios=$(".radio").parents('label');
                let radioV;                
                    for(let i=0;i<radios.length;i++){                    
                        if($(radios[i]).hasClass('active')){
                            radioV=$(radios[i]).children('input').attr('value');
                        }
                    }
                this.optionPersonReg=radioV;
                this.mUpdateForm();
            console.log(`el parametro de busqueda es ${this.optionPersonReg}`);
        },
        mUpdateForm(){
            switch(this.optionPersonReg){
                case 'natural':
                    // aca habilitamos el formulario de apellidos
                    this.is_natural=true;
                    this.new_person.genre=null;
                break;
                
                case 'juridica':
                    // aca inhabilitamos el formulario de apellidos
                    this.is_natural=false;
                    this.new_person.first_last_name=null;
                    this.new_person.second_last_name=null;
                break;
            }
        },
        mValidateForm(){
            if( this.new_person.name===null || this.new_person.name.length < 2){
                toastr.warning('Indique el nombre de la persona u empresa', 'Advertencia');
                return false;
            }
            if(this.is_natural){
                // si es natural verificamos que el apellido este completo
                if( this.new_person.first_last_name===null || this.new_person.first_last_name.length < 2){
                toastr.warning('Indique el apellido de la persona', 'Advertencia');
                return false;
                }   
            }else{
                this.new_person.genre='J';
            }

            if( this.new_person.number_identification===null || this.new_person.number_identification.length < 2){
                toastr.warning('Indique el Numero de identificacion', 'Advertencia');
                return false;
            }
            
            if( this.new_person.issued === 0 ){
                toastr.warning('Seleccione el lugar de expedicion del documento', 'Advertencia');
                return false;
            }

            if( this.new_person.phone <= 0 ){
                toastr.warning('Indique un telefono de referencia', 'Advertencia');
                return false;
            }

            if( this.new_person.nationality <= 0 ){
                toastr.warning('Seleccione una nacionalidad', 'Advertencia');
                return false;
            }

            if( this.new_person.genre === null ){
                toastr.warning('Seleccione un Genero', 'Advertencia');
                return false;
            }
            return true;
        },
        mResetForm(){            
                new_person.name=null;
                new_person.first_last_name=null;
                new_person.second_last_name=null;
                new_person.number_identification=null;
                new_person.issued=0;
                new_person.phone=0;
                new_person.nationality=0;
                new_person.genre=nul;
        },
        mSavePerson(){
            if(this.mValidateForm()){
                let message = {
                    title: 'Registro Persona u Empresa',
                    body: '¿Desea Enviar los Datos al Servidor?'
                }
                
                let npr=new Promise((resolve, reject)=>{
                    this.$dialog
                    .confirm(message)
                    .then(function(dialog) {
                        resolve(true);          
                    })
                    .catch(function() {
                        resolve(false);
                    });
                });
                
                npr.then(async (msg)=>{
                    if(msg){
                        try {
                            // console.log(this.new_person)
                            
                            let aux_nper=await axios.post(`sendNewPersonDeounce?api_token=${Vue.auth.getToken()}`, qs.stringify(this.new_person));
                            if(aux_nper.data.status){
                                toastr.success(aux_nper.data.response, 'Exito');
                                this.mResetForm();
                            }else{
                                toastr.error(aux_nper.data.response, 'Error');
                            }
                        } catch (error) {
                            
                        }
                    }
                })
            }
        }
    },
    filters:{
        upper:function(value){
            return value.toUpperCase();
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/complaints/modalNewPerson.vue